import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=bae24820&"
import script from "./Accordion.vue?vue&type=script&lang=ts&"
export * from "./Accordion.vue?vue&type=script&lang=ts&"
import style0 from "./Accordion.vue?vue&type=style&index=0&id=bae24820&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports